<template>
  <div v-if="image">
    <img :alt="image.fields.title" :class="imageClass" :src="image.fields.file.url"/>
  </div>
</template>

<script>
export default {
  name: "ContentfulImage",
  props: {
    image: {
      type: Object,
      required: true
    },
    imageClass: String
  }
}
</script>

<style scoped>

</style>
